// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","btnsm":"Button_btnsm__X0tCj","btnlg":"Button_btnlg__P0heL","btnmd":"Button_btnmd__wTHGn","btnarr":"Button_btnarr__nfylb"};